import { useCallback, useEffect, useState } from "react";

export const useIsMobile = () => {
  const widthSwitchToMobile = 1280;
  const [isMobile, setIsMobile] = useState(window.innerWidth < widthSwitchToMobile);

  const listenToUpdate = useCallback(() => {
    if (isMobile === false && window.innerWidth < widthSwitchToMobile) {
      setIsMobile(true);
    } else if (isMobile === true && window.innerWidth >= widthSwitchToMobile) {
      setIsMobile(false);
    }
  }, [isMobile]);

  useEffect(() => {
    window.addEventListener("resize", listenToUpdate);

    return () => {
      window.removeEventListener("resize", listenToUpdate);
    };
  }, [listenToUpdate]);

  return isMobile;
};

export default useIsMobile;